import { PortalOptionsService } from "@app/core/services/portal-options.service";

/**
 * AppPortalOptionsInitializationFactory()
 *
 * This function is invoked during application initialization / load.
 * The APP_INITIALIZER is defined in core.module.ts
 *
 * The purpose of this factory implemenation is to establish any custom portal options for the application.
 *
 * @param injector
 */
export function AppPortalOptionsInitializationFactory(portalOptionService: PortalOptionsService): Function {
  // Load settings
  return () => portalOptionService.loadPortalOptions();
}
